var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetAccomodation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20994_306986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854 84.5H0V160H854V84.5Z",
    fill: "white",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.7 91.5H700.4C700.1 91.5 699.9 91.6 699.6 91.8L663.6 120.8C662.7 121.5 663.2 122.9 664.4 122.9H810.8C811.9 122.9 812.4 121.5 811.6 120.8L775.6 91.8C775.2 91.6 775 91.5 774.7 91.5Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.7 89.7H675.9C675.1 89.7 674.4 89 674.4 88.2V51.9C674.4 51.1 675.1 50.4 675.9 50.4H691.7C692.5 50.4 693.2 51.1 693.2 51.9V88.2C693.1 89 692.5 89.7 691.7 89.7Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.7 53.3001H674.8C674.6 53.3001 674.4 53.1001 674.4 52.9001V50.9001C674.4 50.7001 674.6 50.5001 674.8 50.5001H692.7C692.9 50.5001 693.1 50.7001 693.1 50.9001V52.9001C693.1 53.1001 692.9 53.3001 692.7 53.3001Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.901 69.3001C690.901 69.1001 690.701 52.0001 690.201 49.6001C690.101 49.1001 689.801 48.7001 689.401 48.5001C688.301 47.9001 686.401 48.6001 686.401 48.6001L686.301 48.3001C686.401 48.3001 688.301 47.5001 689.601 48.2001C690.101 48.5001 690.401 48.9001 690.601 49.5001C691.101 52.0001 691.301 68.6001 691.301 69.3001H690.901Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.9 47.0001C689.9 50.4001 687.2 50.3001 683.8 50.3001C680.4 50.3001 677.7 50.3001 677.7 47.0001C677.7 43.6001 680.4 38.2001 683.8 38.2001C687.2 38.2001 689.9 43.7001 689.9 47.0001Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.1 42.4001H675.4L680.4 29.2001H687.2L692.1 42.4001Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.7 59.1C690.3 59.1 690 58.8 690 58.4V56.6C690 56.2 690.3 55.9 690.7 55.9C691.1 55.9 691.4 56.2 691.4 56.6V58.4C691.3 58.8 691 59.1 690.7 59.1Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.7 58.2C690.5 58.2 690.4 58.1 690.4 57.9V57.2C690.4 57 690.5 56.9 690.7 56.9C690.9 56.9 691 57 691 57.2V57.9C691 58.1 690.9 58.2 690.7 58.2Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.5 89.7H799.3C800.1 89.7 800.8 89 800.8 88.2V51.9C800.8 51.1 800.1 50.4 799.3 50.4H783.5C782.7 50.4 782 51.1 782 51.9V88.2C782 89 782.7 89.7 783.5 89.7Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.4 53.3001H800.3C800.5 53.3001 800.7 53.1001 800.7 52.9001V50.9001C800.7 50.7001 800.5 50.5001 800.3 50.5001H782.4C782.2 50.5001 782 50.7001 782 50.9001V52.9001C782 53.1001 782.2 53.3001 782.4 53.3001Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 69.5001H785.2C785.2 68.8001 785.4 52.2001 785.9 49.7001C786 49.1001 786.4 48.6001 786.9 48.4001C788.2 47.7001 790.1 48.5001 790.2 48.5001L790.1 48.8001C790.1 48.8001 788.2 48.1001 787.1 48.7001C786.7 48.9001 786.4 49.3001 786.3 49.8001C785.7 52.3001 785.5 69.4001 785.5 69.5001Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.3 47.0001C785.3 50.4001 788 50.3001 791.4 50.3001C794.8 50.3001 797.5 50.3001 797.5 47.0001C797.5 43.6001 794.8 38.2001 791.4 38.2001C788 38.2001 785.3 43.7001 785.3 47.0001Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 42.4001H799.7L794.7 29.2001H787.9L783 42.4001Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.699 58.9C786.099 58.9 786.4 58.6 786.4 58.3L786.499 56.6C786.499 56.2 786.2 55.9 785.9 55.9C785.5 55.9 785.199 56.2 785.199 56.5L785.099 58.2C784.999 58.6 785.299 58.9 785.699 58.9Z",
    fill: "#EA662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.7 58.0001C785.9 58.0001 786 57.9001 786 57.7001V57.0001C786 56.8001 785.9 56.7001 785.7 56.7001C785.5 56.7001 785.4 56.8001 785.4 57.0001V57.7001C785.4 57.9001 785.5 58.0001 785.7 58.0001Z",
    fill: "#F9BB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.2 82.5H700.5C698.5 82.5 696.9 80.9001 696.9 78.9001V30.9C696.9 28.9 698.5 27.3 700.5 27.3H774.2C776.2 27.3 777.8 28.9 777.8 30.9V78.9001C777.8 80.9001 776.2 82.5 774.2 82.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.1 104.9H687C684.6 104.9 682.7 103 682.7 100.6V80.5H792.4V100.6C792.4 103 790.5 104.9 788.1 104.9Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.5 58H710.7L682.7 80.5H792.4L764.5 58Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 59.9L770.9 57.4C769.9 56.6 768.6 56.1 767.2 56.1H708C706.7 56.1 705.4 56.6 704.3 57.4L700.8 60.3L774 59.9Z",
    className: "illustration_primary-ultralight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.8 60.2L686 72.1C681.7 75.6 684.1 82.5 689.7 82.5H785.5C791 82.5 793.5 75.5 789.2 72.1L774 59.9L700.8 60.2Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.3 113.4H690.4C689.5 113.4 688.7 112.7 688.7 111.7V100.4C688.7 99.5 689.4 98.7 690.4 98.7H695.3C696.2 98.7 697 99.4 697 100.4V111.7C696.9 112.7 696.2 113.4 695.3 113.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.6 113.4H779.7C778.8 113.4 778 112.7 778 111.7V100.4C778 99.5 778.7 98.7 779.7 98.7H784.6C785.5 98.7 786.3 99.4 786.3 100.4V111.7C786.3 112.7 785.5 113.4 784.6 113.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.3 61.8L775.1 59.5L699.7 59.8L697.3 61.7C696.6 62.2 697 63.3 697.9 63.3H777.8C778.6 63.3 778.9 62.3 778.3 61.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.4 57.4H716C713.6 57.4 711.6 55.4 711.6 53V47.3C711.6 44.9 713.6 42.9 716 42.9H730.4C732.8 42.9 734.8 44.9 734.8 47.3V53C734.8 55.4 732.8 57.4 730.4 57.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.2 57.4H744.8C742.4 57.4 740.4 55.4 740.4 53V47.3C740.4 44.9 742.4 42.9 744.8 42.9H759.2C761.6 42.9 763.6 44.9 763.6 47.3V53C763.6 55.4 761.6 57.4 759.2 57.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M781.5 75.1H692.8C692.6 75.1 692.5 75 692.5 74.8C692.5 74.6 692.6 74.5 692.8 74.5H781.5C781.7 74.5 781.8 74.6 781.8 74.8C781.8 75 781.7 75.1 781.5 75.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M843.3 44.5C841.8 44.9001 840.3 45.1 838.7 45.1C828.3 45.1 819.8 36.6 819.8 26.2001C819.8 15.8001 828.3 7.30005 838.7 7.30005C840.3 7.30005 841.9 7.50005 843.3 7.90005C836.7 11.3 832.2 18.2001 832.2 26.2001C832.2 34.2001 836.7 41.1 843.3 44.5Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.4 29.2L617 -51.5L737.1 -54.6L687.2 29.2H680.4Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.7 29.2L847.6 -54.6H737.9L787.9 29.2H794.7Z",
    fill: "#FFE600"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20994_306986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetAccomodation);
export default __webpack_public_path__ + "static/media/BackgroundWidgetAccomodation.c24f184a.svg";
export { ForwardRef as ReactComponent };